import { Storage } from "@faire/web--source/common/Storage";
import { ISignUpRequest } from "@faire/web-api--source/indigofair/data/ISignUpRequest";
export var signUpCache = {
    save: saveSignUpRequest,
    clear: clearSignUpRequest,
    get: getSignUpRequest
};
function saveSignUpRequest(data) {
    Storage.session.setItem(SIGNUP_REQUEST_DATA_KEY, JSON.stringify(data));
}
function clearSignUpRequest() {
    Storage.session.removeItem(SIGNUP_REQUEST_DATA_KEY);
}
function getSignUpRequest() {
    var data = Storage.session.getItem(SIGNUP_REQUEST_DATA_KEY);
    if (data) {
        try {
            return JSON.parse(data);
        } catch (e) {
            return ISignUpRequest.build();
        }
    }
    return ISignUpRequest.build();
}
var SIGNUP_REQUEST_DATA_KEY = "SIGNUP_REQUEST_DATA_KEY";
